import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBoolean } from "@ispb/react-hooks";
import { Fragment } from "react";
import { Case, Default, Switch } from "react-if";
import ThumbnailBox from "./box/ThumbnailBox.js";
import DefaultThumbnail from "./content/DefaultThumbnail.js";
import ImageThumbnail from "./content/ImageThumbnail.js";
import VideoThumbnail from "./content/VideoThumbnail.js";
import ThumbnailLightBox from "./ThumbnailLightBox.js";
export default function Thumbnail(props) {
    const aspectRatio = (() => {
        if (props.originalSize) {
            if (props.file.aspectRatio !== undefined) {
                return props.file.aspectRatio;
            }
        }
        if (props.aspectRatio !== undefined) {
            return props.aspectRatio;
        }
    })();
    const lightBox = useBoolean(false);
    const onClick = (() => {
        if (props.onClick !== undefined) {
            return props.onClick;
        }
        return lightBox.on;
    })();
    const neighbors = props.neighbors ?? [{ type: "thumbnail", file: props.file }];
    return (_jsxs(Fragment, { children: [_jsx(ThumbnailBox, { ...props, aspectRatio: aspectRatio, onClick: onClick, children: _jsxs(Switch, { children: [_jsx(Case, { condition: props.file.type.startsWith("image/"), children: _jsx(ImageThumbnail, { originalSize: props.originalSize, file: props.file }) }), _jsx(Case, { condition: props.file.type.startsWith("video/"), children: _jsx(VideoThumbnail, { play: props.embed, file: props.file }) }), _jsx(Default, { children: _jsx(DefaultThumbnail, { file: props.file }) })] }) }), _jsx(ThumbnailLightBox, { show: lightBox.value, close: lightBox.off, thumbnails: neighbors, index: props.index })] }));
}
